var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-layout",
    { attrs: { "md-flex": "100" } },
    [
      _c(
        "md-layout",
        { attrs: { "md-flex": "90", "md-flex-offset": "5" } },
        [
          _c(
            "md-card",
            { staticClass: "md-table-card content-table" },
            [
              _c("md-card-header", { staticClass: "md-title" }, [
                _vm._v("Billing reporting")
              ]),
              _c(
                "form",
                {
                  staticClass: "search-form",
                  attrs: { novalidate: "novalidate" },
                  on: {
                    submit: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.searchForBilling.apply(null, arguments)
                    }
                  }
                },
                [
                  _c(
                    "md-layout",
                    { attrs: { "md-gutter": 24 } },
                    [
                      _c(
                        "md-layout",
                        { attrs: { "md-flex": "20", "md-flex-small": "30" } },
                        [
                          _c(
                            "md-input-container",
                            [
                              _c("label", { attrs: { for: "criteria" } }, [
                                _vm._v("Account")
                              ]),
                              _c(
                                "md-select",
                                {
                                  attrs: { id: "criteria" },
                                  on: { selected: _vm.searchForBilling },
                                  model: {
                                    value: _vm.filters.accountId,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filters, "accountId", $$v)
                                    },
                                    expression: "filters.accountId"
                                  }
                                },
                                _vm._l(_vm.accounts, function(account) {
                                  return _c(
                                    "md-option",
                                    {
                                      key: account._id,
                                      attrs: { value: account._id }
                                    },
                                    [_vm._v(_vm._s(account.name))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "md-layout",
                        { attrs: { "md-flex": "20", "md-flex-small": "30" } },
                        [
                          _c(
                            "md-input-container",
                            [
                              _c("label", { attrs: { for: "criteria" } }, [
                                _vm._v("Month")
                              ]),
                              _c(
                                "md-select",
                                {
                                  attrs: { id: "criteria" },
                                  on: { selected: _vm.searchForBilling },
                                  model: {
                                    value: _vm.filters.month,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filters, "month", $$v)
                                    },
                                    expression: "filters.month"
                                  }
                                },
                                _vm._l(_vm.months, function(month) {
                                  return _c(
                                    "md-option",
                                    {
                                      key: month.value,
                                      attrs: { value: month.value }
                                    },
                                    [_vm._v(_vm._s(month.name))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "md-layout",
                        { attrs: { "md-flex": "20", "md-flex-small": "30" } },
                        [
                          _c(
                            "md-input-container",
                            [
                              _c("label", { attrs: { for: "criteria" } }, [
                                _vm._v("Year")
                              ]),
                              _c(
                                "md-select",
                                {
                                  attrs: { id: "criteria" },
                                  on: { selected: _vm.searchForBilling },
                                  model: {
                                    value: _vm.filters.year,
                                    callback: function($$v) {
                                      _vm.$set(_vm.filters, "year", $$v)
                                    },
                                    expression: "filters.year"
                                  }
                                },
                                _vm._l(_vm.years, function(year) {
                                  return _c(
                                    "md-option",
                                    {
                                      key: year.value,
                                      attrs: { value: year.value }
                                    },
                                    [_vm._v(_vm._s(year.value))]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "md-layout",
                        {
                          attrs: {
                            "md-flex": "10",
                            "md-flex-small": "10",
                            "md-flex-xsmall": "100",
                            "md-vertical-align": "center",
                            "md-align-xsmall": "center"
                          }
                        },
                        [
                          _c(
                            "md-button",
                            {
                              staticClass:
                                "search-btn md-raised md-icon-button btn",
                              attrs: {
                                type: "submit",
                                disabled: _vm.loading || _vm.$v.$invalid
                              }
                            },
                            [
                              _c("md-icon", {
                                staticClass: "icon",
                                attrs: { "md-iconset": "fa fa-search" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "stitch-loader",
                { attrs: { loading: _vm.loading, size: 45 } },
                [
                  _c("div", { staticClass: "table" }, [
                    _c("div", { staticClass: "titleLine styleRow" }, [
                      _c("p", { staticClass: "rowElements" }, [
                        _vm._v("Bandwidth Count")
                      ]),
                      _c("p", { staticClass: "rowElements" }, [
                        _vm._v("Bandwidth GB")
                      ]),
                      _c("p", { staticClass: "rowElements" }, [
                        _vm._v("Bandwidth Total cost")
                      ]),
                      _c("p", { staticClass: "rowElements" }, [
                        _vm._v("MediaConvert Total")
                      ]),
                      _c("p", { staticClass: "rowElements" }, [
                        _vm._v("TOTAL BILL")
                      ])
                    ]),
                    _c("div", { staticClass: "styleRow colorHover" }, [
                      _c("div", { staticClass: "rowElements" }, [
                        _vm._v(
                          _vm._s(
                            _vm.bill.billingBandwith.missRequestsCount !=
                              "no data"
                              ? _vm.bill.billingBandwith.missRequestsCount +
                                  _vm.bill.billingBandwith.hitTotalRequestsCount
                              : "no data"
                          )
                        )
                      ]),
                      _c("div", { staticClass: "rowElements" }, [
                        _vm._v(
                          _vm._s(
                            _vm.bill.billingBandwith.missTotalGB != "no data"
                              ? _vm.bill.billingBandwith.missTotalGB +
                                  _vm.bill.billingBandwith.hitTotalGB +
                                  " GB"
                              : "no data"
                          )
                        )
                      ]),
                      _c("div", { staticClass: "rowElements" }, [
                        _vm._v(
                          _vm._s(
                            _vm.calculateBandwidthTotal() != "NaN"
                              ? "$" + _vm.calculateBandwidthTotal()
                              : "no data"
                          )
                        )
                      ]),
                      _c("div", { staticClass: "rowElements" }, [
                        _vm._v(
                          _vm._s(
                            _vm.mediaConvertTotal() != "NaN"
                              ? "$" + _vm.mediaConvertTotal()
                              : "no data"
                          )
                        )
                      ]),
                      _c("div", { staticClass: "rowElements" }, [
                        _vm._v(
                          _vm._s(
                            _vm.bill.total != "no data"
                              ? "$" + _vm.bill.total
                              : "no data"
                          )
                        )
                      ])
                    ])
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11c89e94", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11c89e94","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/report/BillingTable.vue
// module id = 1003
// module chunks = 0